import React from "react";
export const afYearlyTHead = [
  "F_Year",
  "AF Cases",
  "Avg Cases/d",
  "Detention Avg/d",
  "Goods",
  "Pass",
  "Train Delay",
  "Delay Hrs",
];
export const ahWiseTHead = [
  "Asset Group",
  "AF Cases",
  "Avg Cases/d",
  "Detention Avg/d",
  // "Goods",
  // "Pass",
  "Train Delay",
  "Delay Hrs",
];
export const sectionWiseThead = [
  "Asset Group",
  "AF Cases",
  "Avg Cases/d",
  "Detention Avg/d",
  "Duration",
  // "Pass",
  "Train Delay",
  "Delay Hrs",
];

export const remarkTableHeader = {
  "9FAILUR_DATE_TIMEFROM": "Failure date time from",
  "10FAILUR_DATE_TIMETO": "Failure date time to",
  ASSET_GROUP: "Asset group",
  SUB_CAUSE: "Sub cause",
  SECTION_NAME: "Section",
  BLOCK_SECTION_STATION: "Block section / station",
  UP_DOWN: "Direction",
  "11DURATION": "Duration",
  "8TYPE_OF_FAILUR": "Type of failure",
};
